import lazyLoadView from "@router/lazyload-view";
import routeError from "@router/route-error";
import store from '@src/store'

export default [
  // 菁英招募
  {
    path: '/elite',
    name: 'elite',
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        next({ name: 'elite-join' });
      },
      alias: "elite",
      title: '菁英招募'
    },
  },
  // 加入零壹
  {
    path: '/elite/join',
    name: 'elite-join',
    component: () => lazyLoadView(import('@views/Elite/Index')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const aboutList = await store.dispatch('about/fetchElite')
          routeTo.params.aboutCompany = aboutList.join01
          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }));
        }
      },
      alias: "join",
      title: '加入零壹'
    },
    props: (route) => ({
      aboutCompany: route.params.aboutCompany || {},
    })
  },
  // 成長在零壹
  {
    path: '/elite/grow',
    name: 'elite-grow',
    component: () => lazyLoadView(import('@views/Elite/Grow')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const aboutList = await store.dispatch('about/fetchElite')
          routeTo.params.aboutCompany = aboutList.grow01
          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }));
        }
      },
      alias: "grow",
      title: '成長在零壹'
    },
    props: (route) => ({
      aboutCompany: route.params.aboutCompany || {},
    })
  },
  // 生活在零壹
  {
    path: '/elite/live',
    name: 'elite-live',
    component: () => lazyLoadView(import('@views/Elite/Live')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const aboutList = await store.dispatch('about/fetchElite')
          routeTo.params.aboutCompany = aboutList.life01
          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }));
        }
      },
      alias: 'live',
      title: '生活在零壹'
    },
    props: (route) => ({
      aboutCompany: route.params.aboutCompany || {},
    })
  },

  // // 關於零壹 手機版選單
  // {
  //   path: '/about/menu',
  //   name: 'about-menu',
  //   component: () => lazyLoadView(import('@views/MobilePageMenu/Index')),
  //   meta: {
  //     async beforeResolve(routeTo, routeFrom, next) {
  //       try {
  //         const vw = document.body.clientWidth
  //         if (vw > 676) {
  //           next({ name: 'about-zerone' });
  //         }
  //         next()
  //       } catch (error) {
  //         routeError(error, routeTo, next({ name: '404' }));
  //       }
  //     },
  //     title: '關於零壹'
  //   },
  // },
]
